import { render } from "./call-to-action.vue?vue&type=template&id=5bc97827"
import script from "./call-to-action.vue?vue&type=script&lang=js"
export * from "./call-to-action.vue?vue&type=script&lang=js"
script.render = render

export default script